import Canvastoimg from "wtc-canvastoimg";

Vue.component("usercardedit", {
  props: {
    edit_info: Object,
  },
  template: `
  <div style="background: #EEEEEE;height: 100vh;">
		  <!--  标准名片   -->
		  <div class="usercard-container-n">
		    <div v-bind:class="[isDarker ? 'usercard-container-normal-n darker' : 'usercard-container-normal-n light']" v-bind:style="{ backgroundColor: curColor }">
		      <div class="usercard-head-box">
		          <div class="usercard-head">
		            <img :src="cardInfo.ui.headimg">
		          </div>
		          <div>
		            <div class="usercard-name">{{cardInfo.ui.name}}</div>
		            <div class="usercard-company">
									<span v-if="inputJob && cardInfo.ui && cardInfo.ui.company">{{inputJob + ' | ' + cardInfo.ui.company}}</span>
									<span v-else-if="inputJob">{{inputJob}}</span>
									<span v-else="cardInfo.ui && cardInfo.ui.company">{{cardInfo.ui.company ? cardInfo.ui.company : ''}}</span>
								</div>
		          </div>
		      </div>
		      <div class="usercard-nav-box">
		        <div class="usercard-nav" v-for="(item,index) in newNavData" :key="index">
		  			  <img class="nav-icon" v-if="isDarker" :src="item.ico_darker">
		          <img class="nav-icon" v-else :src="item.ico_light">
		          <label>{{item.name}}</label>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="edit-usercard-container">
		    <div class="edit-usercard-box">
		      <div class="title">头像</div>
		      <div class="edit-input-box">
		        <img :src="cardInfo.ui.headimg"/>
		      </div>
		      <div class="edit-icon">
		        <img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/more.png">
		      </div>
		    </div>
		    <div class="edit-usercard-box">
		      <div class="title">姓名</div>
		      <div class="edit-input-box">{{cardInfo.ui.name}}</div>
		    </div>
		    <div class="edit-usercard-box">
		      <div class="title">公司简称</div>
		      <div class="edit-input-box">{{cardInfo.ui.company}}</div>
		    </div>
		    <div class="edit-usercard-box">
		      <div class="title">职位</div>
		      <div class="edit-input-box">
		        <input class="edit-input" v-model="inputJob" placeholder="请输入">
		      </div>
		    </div>
		    <div class="edit-usercard-box">
		      <div class="title">您的手机号</div>
		      <div class="edit-input-box">{{cardInfo.ui.mobile}}</div>
		    </div>
		  </div>
		  <div class="edit-usercard-color">
		    <div class="edit-usercard-container">
					<div class="edit-usercard-box">
						<div class="title">文章底部显示名片</div>
						<div class="edit-input-box">
							<div class="edit-input-box">
								<label><input class="mui-switch" v-model="isOpen" type="checkbox"></label>
							</div>
						</div>
					</div>
		      <div class="edit-usercard-box">
		        <div class="title">名片颜色</div>
		        <div class="edit-input-box">
		          <div v-for="(item,index) in colorList" :key="index" v-bind:class="[curColor == item  ? 'edit-color-cur edit-color-' + index : 'edit-color-' + index]" class="edit-color-item" @click="handleColor(item)"></div>
		        </div>
		      </div>
		    </div>
		  </div>
		  <div class="edit-btn-container">
		    <div class="edit-btn-box" @click="handleCancel">取消</div>
				<div class="space"></div>
		    <div class="edit-btn-box edit-btn-save" @click="handleSubmit">保存</div>
		  </div>   
  </div>
  `,
  data() {
    return {
      isShowUserCard: false,
      newNavData: null,
      cardInfo: null,
      cardConfig: null,
      inputJob: "",
      curColor: "",
      isOpen: true,
      colorList: ["#D6BF8E", "#D7D7D8", "#8D9197", "#212324", "#0B7FE8", "#4EC6E0"],
    };
  },
  computed: {
    isDarker() {
      if (this.curColor == "#D6BF8E" || this.curColor == "#D7D7D8") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    handleCancel() {
      this.$emit("handle-edit", false);
    },
    handleColor(color) {
      this.curColor = color;
    },
    handleSubmit() {
      let params = {
        bgcolor: this.curColor || "#D6BF8E",
        cardtype: this.cardConfig?.cardtype || 1,
        job: this.inputJob || "",
        qrcode: "",
        downshow: this.isOpen == false ? 0 : 1,
        pageid: myPageData.PageId,
        openid: this.cardInfo.openid,
      };
      if (this.cardConfig?.id) {
        params.id = this.cardConfig.id;
      }
      comreq.submitCardConfig(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$emit("handle-edit", false, null, true);
        } else {
          alert(res.msg);
        }
      });
    },
  },
  created() {
    console.log("edit_info", JSON.parse(JSON.stringify(this.edit_info)));

    this.cardInfo = this.edit_info.cardInfo;
    this.cardConfig = this.edit_info.cardConfig;
    this.newNavData = this.edit_info.newNavData || [];
    if (this.cardConfig?.job) {
      this.inputJob = this.cardConfig?.job;
    }
    if (this.cardConfig?.downshow == 0) {
      this.isOpen = false;
    }
    this.curColor = this.cardConfig?.bgcolor || "#D6BF8E";
  },
});
